import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5c36d0e0")

_pushScopeId("data-v-5c36d0e0")
const _hoisted_1 = { class: "modal-wrap default-modal appointment-modal" }
const _hoisted_2 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "appointmentCreateModel",
  tabindex: "-1",
  "aria-labelledby": "feedbackModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "shadowed-card bg-white mb-2 p-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "text-success" }
const _hoisted_9 = {
  class: "modal-body",
  id: "appointmentModelScroll"
}
const _hoisted_10 = { class: "form-wrap" }
const _hoisted_11 = { action: "" }
const _hoisted_12 = { class: "bg-light p-3 mb-3 rounded" }
const _hoisted_13 = { class: "form-group mb-0" }
const _hoisted_14 = { for: "" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_16 = { class: "inline-items" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { for: "" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = { class: "flex-grow-1" }
const _hoisted_22 = { class: "dropdown color-select-wrap mt-2 ml-2" }
const _hoisted_23 = {
  class: "dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_24 = { class: "dropdown-menu" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#fdc689"}
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#a3d39c"}
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#f49ac1"}
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#6dcff6"}
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#fbe65d"}
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#cba9f8"}
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#fe7a72"}
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#fc95b8"}
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#10d0cf"}
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#00c489"}
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#73d1b5"}
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#fad1e3"}
}, null, -1)
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = { class: "to-upper" }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = {
  class: "to-upper",
  for: ""
}
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = { for: "allDay" }
const _hoisted_46 = {
  key: 0,
  class: "bg-light p-3 mb-3 rounded"
}
const _hoisted_47 = { class: "form-group mb-0" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { for: "" }
const _hoisted_50 = /*#__PURE__*/_createVNode("input", {
  type: "text",
  class: "form-control",
  placeholder: "www.locationurl.com"
}, null, -1)
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { for: "" }
const _hoisted_53 = /*#__PURE__*/_createVNode("input", {
  type: "text",
  class: "form-control",
  placeholder: "www.locationurl.com"
}, null, -1)
const _hoisted_54 = {
  key: 1,
  class: "bg-light p-3 mb-3 rounded"
}
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = {
  class: "to-upper",
  for: "location"
}
const _hoisted_57 = { class: "bg-light p-3 mb-3 rounded" }
const _hoisted_58 = { class: "form-group mb-0" }
const _hoisted_59 = { for: "" }
const _hoisted_60 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_61 = { class: "form-group" }
const _hoisted_62 = { for: "" }
const _hoisted_63 = { class: "modal-footer" }
const _hoisted_64 = { class: "form-group" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_GoogleMapAppointment = _resolveComponent("GoogleMapAppointment")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_AddNotification = _resolveComponent("AddNotification")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeAppointmentModal && _ctx.closeAppointmentModal(...args))),
                class: "close",
                "aria-label": "Close"
              }, [
                _hoisted_6
              ]),
              _createVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t('add_appointment')), 1),
              _createVNode("p", null, [
                _createVNode("small", _hoisted_8, _toDisplayString(_ctx.$t('add_appointment_with_email')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.errorList,
                hasError: _ctx.state.isErrorStatus
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_10, [
                _createVNode("form", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("label", _hoisted_14, [
                        _createTextVNode(_toDisplayString(_ctx.$t('meeting_via')) + " ", 1),
                        _hoisted_15
                      ]),
                      _createVNode("div", _hoisted_16, [
                        _createVNode("ul", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.meetingVia, (meeting) => {
                            return (_openBlock(), _createBlock("li", { key: meeting }, [
                              _createVNode("label", null, [
                                _withDirectives(_createVNode("input", {
                                  type: "radio",
                                  name: "optionsRadios",
                                  id: meeting.name,
                                  value: meeting.value,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.meetingType = $event)),
                                  onChange: ($event: any) => (_ctx.checkLogin(meeting.value))
                                }, null, 40, ["id", "value", "onChange"]), [
                                  [_vModelRadio, _ctx.state.meetingType]
                                ]),
                                _createTextVNode(" " + _toDisplayString(meeting.name), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("label", _hoisted_18, [
                      _createTextVNode(_toDisplayString(_ctx.$t('add_new_appointment_title')) + " ", 1),
                      _hoisted_19
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          placeholder: "Project discuss",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.title = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.title]
                        ])
                      ]),
                      _createVNode("div", _hoisted_22, [
                        _createVNode("button", _hoisted_23, [
                          _createVNode("span", {
                            class: "color-eclipse",
                            style: `background-color:${_ctx.state.data.bgColor}`
                          }, null, 4)
                        ]),
                        _createVNode("div", _hoisted_24, [
                          _createVNode("a", {
                            class: "dropdown-item color-selected",
                            href: "javascript:void(0)",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.slotcolorSelector('#fdc689')))
                          }, [
                            _hoisted_25
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.slotcolorSelector('#a3d39c')))
                          }, [
                            _hoisted_26
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.slotcolorSelector('#f49ac1')))
                          }, [
                            _hoisted_27
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.slotcolorSelector('#6dcff6')))
                          }, [
                            _hoisted_28
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.slotcolorSelector('#fbe65d')))
                          }, [
                            _hoisted_29
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.slotcolorSelector('#cba9f8')))
                          }, [
                            _hoisted_30
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.slotcolorSelector('#fe7a72')))
                          }, [
                            _hoisted_31
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.slotcolorSelector('#fc95b8')))
                          }, [
                            _hoisted_32
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.slotcolorSelector('#10d0cf')))
                          }, [
                            _hoisted_33
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.slotcolorSelector('#00c489')))
                          }, [
                            _hoisted_34
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.slotcolorSelector('#73d1b5')))
                          }, [
                            _hoisted_35
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.slotcolorSelector('#fad1e3')))
                          }, [
                            _hoisted_36
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_37, [
                    _createVNode("div", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        _createVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('meeting_start_date_time')), 1),
                        _createVNode(_component_v_date_picker, {
                          modelValue: _ctx.state.data.range.start,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.data.range.start = $event)),
                          mode: "dateTime"
                        }, {
                          default: _withId(({ inputValue, inputEvents }) => [
                            _createVNode("input", _mergeProps({
                              class: "px-2 py-1 border rounded focus:outline-none focus:border-blue-300",
                              value: inputValue
                            }, _toHandlers(inputEvents)), null, 16, ["value"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_41, [
                      _createVNode("div", _hoisted_42, [
                        _createVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('meeting_end_date_time')), 1),
                        _createVNode(_component_v_date_picker, {
                          modelValue: _ctx.state.data.range.end,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.data.range.end = $event)),
                          mode: "dateTime"
                        }, {
                          default: _withId(({ inputValue, inputEvents }) => [
                            _createVNode("input", _mergeProps({
                              class: "px-2 py-1 border rounded focus:outline-none focus:border-blue-300",
                              value: inputValue
                            }, _toHandlers(inputEvents)), null, 16, ["value"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_44, [
                    _createVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('all_day')), 1),
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      id: "allDay",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.allDay = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.allDay]
                    ])
                  ]),
                  (_ctx.state.meetingType == 'skype')
                    ? (_openBlock(), _createBlock("div", _hoisted_46, [
                        _createVNode("div", _hoisted_47, [
                          (_ctx.state.meetingType == 'skype')
                            ? (_openBlock(), _createBlock("div", _hoisted_48, [
                                _createVNode("label", _hoisted_49, _toDisplayString(_ctx.$t('meeting_url_id')), 1),
                                _hoisted_50
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.state.meetingType == 'zoom')
                            ? (_openBlock(), _createBlock("div", _hoisted_51, [
                                _createVNode("label", _hoisted_52, _toDisplayString(_ctx.$t('meeting_code')), 1),
                                _hoisted_53
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.meetingType == 'physical')
                    ? (_openBlock(), _createBlock("div", _hoisted_54, [
                        _createVNode("div", _hoisted_55, [
                          _createVNode("label", _hoisted_56, _toDisplayString(_ctx.$t('location')), 1),
                          _createVNode(_component_GoogleMapAppointment, {
                            latitude: _ctx.latitude,
                            longitude: _ctx.longitude,
                            location: _ctx.state.location,
                            visible: _ctx.showMap,
                            "onUpdate:latitude": _ctx.updateLatitude,
                            "onUpdate:longitude": _ctx.updateLongitude,
                            "onUpdate:location": _ctx.updateLocation
                          }, null, 8, ["latitude", "longitude", "location", "visible", "onUpdate:latitude", "onUpdate:longitude", "onUpdate:location"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_57, [
                    _createVNode("div", _hoisted_58, [
                      _createVNode("label", _hoisted_59, [
                        _createTextVNode(_toDisplayString(_ctx.$t('invite_user')) + " ", 1),
                        _hoisted_60
                      ]),
                      _createVNode(_component_Multiselect, {
                        taggable: true,
                        modelValue: _ctx.state.data.tags.value,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.state.data.tags.value = $event)),
                        mode: "tags",
                        searchable: true,
                        options: _ctx.state.data.tags.options,
                        onTag: _ctx.addTag,
                        createTag: true
                      }, null, 8, ["modelValue", "options", "onTag"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_61, [
                    _createVNode("label", _hoisted_62, _toDisplayString(_ctx.$t('appointment')), 1),
                    _withDirectives(_createVNode("textarea", {
                      class: "form-control",
                      placeholder: "note if any",
                      rows: "5",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.state.note = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.note]
                    ])
                  ]),
                  _createVNode(_component_AddNotification, { onNotificationList: _ctx.updateNotificationList }, null, 8, ["onNotificationList"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_63, [
              _createVNode("div", _hoisted_64, [
                _createVNode("button", {
                  class: "btn default-btn mr-3",
                  type: "submit",
                  disabled: _ctx.state.postLoadingCreateAppointmen,
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.saveAppointment && _ctx.saveAppointment(...args)))
                }, _toDisplayString(_ctx.state.postLoadingCreateAppointmen ? "Creating..." : "Create"), 9, ["disabled"]),
                _createVNode("button", {
                  class: "btn secondary-btn",
                  type: "submit",
                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.closeAppointmentModal && _ctx.closeAppointmentModal(...args)))
                }, _toDisplayString(_ctx.$t('cancel')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.SuccessFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
})